import { render, staticRenderFns } from "./list-with-covers.vue?vue&type=template&id=e9718de8"
import script from "./list-with-covers.vue?vue&type=script&lang=js"
export * from "./list-with-covers.vue?vue&type=script&lang=js"
import style0 from "./list-with-covers.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports